import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./style.scss";
import Html from "./Html";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../Pages/actions/user";
import ApiClient from "../../../methods/api/apiClient";
import { memo } from "react";
import socketModel from "../../../models/socketModel";

const Header = memo(function Header({ setIsOpen, isOpen }) {
  const user = useSelector((state) => state.user);
  const toggle = () => {
    setIsOpen(!isOpen);
    localStorage.setItem("sidebar", !isOpen);
  };
  const [isOpen1, setIsOpen1] = useState(false);
  let messagecount = localStorage.getItem("unreadMessages") || 0;
  const [messageCount, setUnreadMessagesCount] = useState(messagecount);
  const history = useNavigate();
  const dispatch = useDispatch();
  const searchState = { data: "" };

  const Logout = () => {
    dispatch(logout());
    localStorage.removeItem("persist:admin-app");
    localStorage.removeItem("token");
    socketModel.emit("user-offline", { userId: user?._id || user?.id });
    socketModel.disconnect();
    history("/login");
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    setSearch(searchState.data);
  }, [searchState]);

  const [search, setSearch] = useState("");

  const searchHandle = (e) => {
    e.preventDefault();
  };

  const searchChange = (e) => {
    setSearch(e);
    if (!e) {
    }
  };

  const clear = () => {
    setSearch("");
  };

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      const shouldBeOpen = screenWidth > 767;
      setIsOpen(!shouldBeOpen);
      localStorage.setItem("sidebar", shouldBeOpen);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Html
      isOpen={isOpen}
      toggle={toggle}
      searchHandle={searchHandle}
      search={search}
      user={user}
      searchChange={searchChange}
      isOpen1={isOpen1}
      clear={clear}
      Logout={Logout}
      messageCount={messageCount}
    />
  );
});

export default Header;
